export enum GiftCodeDateType {
  CREATED_AT = 'createdAt',
  ISSUED_AT = 'issuedAt',
  USED_AT = 'usedAt'
}
